module.exports = __webpack_public_path__ + "img/file-earmark-fill.9d16cf96.svg";